(function () {
  // Bu fonksiyon header yüksekliğini bulur ve CSS değişkenini ayarlar
  function setStickyTopVar(root){
    var header = document.querySelector('header');
    var hh = (header ? header.offsetHeight : 80) + 16; // 16px rahatlık
    // root verilmemişse :root’a yaz; verilirse ilgili bölüme yaz (ikisi de olur)
    (root || document.documentElement).style.setProperty('--lh-sticky-top', hh + 'px');
  }

  // Sayfadaki tüm ürün bölümleri için ayarla
  function initForAllProducts(){
    // Ürün sayfalarında genellikle tek bölüm var; bazen quick-view/featured de olabilir
    var sections = document.querySelectorAll('.template-product, section[id^="MainProduct-"], .product');
    if(!sections.length){ setStickyTopVar(); return; }
    sections.forEach(function(sec){ setStickyTopVar(sec); });
  }

  // İlk yüklemede
  initForAllProducts();

  // Ekran döndürme/resize’da güncelle
  ['load','resize','orientationchange'].forEach(function(evt){
    window.addEventListener(evt, initForAllProducts);
  });

  // Shopify Theme Editor veya ajax yüklemelerinde bölüm yeniden gelirse yakala
  var mo = new MutationObserver(function(){
    initForAllProducts();
  });
  mo.observe(document.documentElement, {subtree:true, childList:true});
})();